import React from 'react'

const ReportsContext = React.createContext({})

export const ReportsProvider = ReportsContext.Provider;
export const ReportsConsumer = ReportsContext.Consumer;
export default ReportsContext;